import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRightFromBracket } from '@fortawesome/free-solid-svg-icons';
import { useHistory, useLocation } from 'react-router-dom';
import { useAuthContext } from '../context';

const LogoutButton = (props: { label: string }) => {
  const { label } = props;
  const authContext = useAuthContext();
  const { signOut } = authContext;
  const history = useHistory();
  const location = useLocation();

  // Determine the style based on location
  const isTopNav = location.pathname.includes('/entry/') || location.pathname === '/';

  return (
    <button
      key="logout-button"
      className={`tw-flex tw-items-center tw-font-semibold ${
        isTopNav ? 'tw-text-primary-700 tw-bg-white' : 'tw-bg-transparent tw-text-primary-700'
      } tw-border-none lg:tw-text-base tw-text-sm`}
      onClick={() => {
        if (signOut !== undefined) {
          console.log('signing out');
          sessionStorage.removeItem('stripeCustomerId');
          signOut();
        }
        history.push(`/`);
      }}
    >
      <FontAwesomeIcon className="tw-mr-2" icon={faArrowRightFromBracket} />
      {label}
    </button>
  );
};

export default LogoutButton;
